import Weather from './Components/Weather';

function App() {
  return (
    < >
     <Weather />
    </>
  );
}

export default App;
